import playImg from './play.png';
import { Component } from 'react';
import $ from 'jquery';
import { VolumeBlock } from '../volumeBLock/VolumeBlock';

export class SoundsItem extends Component {
    constructor (props) {
        super(props);
        this.id = this.props.id;
        this.img = this.props.img;
        this.sound = this.props.sound;
        this.state = {
            play: false
        }
        this.audio = new Audio(this.sound);
        this.audio.loop = true;
    }

    onBtn = (e) => {
        if (this.state.play == true) {
            $("." + this.id).animate({
                width: "0px"
            }, 100);
            setTimeout(() => {
                this.setState({
                    play: !this.state.play
                })
            }, 100);
        } else {
            this.setState({
                play: !this.state.play
            })
        }
    }

    render () {
        const playBlock = this.state.play == true ? <img src={playImg} onClick={this.onBtn} className={"play " + this.id} alt="play" draggable="false" /> : null;
        const volumeBLock = this.state.play == true ? <VolumeBlock audio={this.audio} /> : null;

        if (this.state.play) {
            this.audio.play();
            this.audio.autoplay = true;
        } else {
            this.audio.pause();
        }
    
        return (
            <div className="sounds-item">
                {playBlock}
                <div className="logo" onClick={this.onBtn}>
                    <img src={this.img} draggable="false" alt="logo" />
                </div>
                {volumeBLock}
            </div>
        );
    }
}